import { useEffect, useState } from 'react';
import { api, urls } from '../../../services/api'
import { IAcessoRapidoItem } from '../../../types/acessoRapido';

import { Section } from '../../../components/ui/Section';
import { SectionTitle } from '../../../components/ui/SectionTitle';
import { Link } from 'lucide-react';
import { Skeleton } from '../../../components/ui/Skeleton';

export function AcessoRapido() {
	const [acessoRapidoItem, setAcessoRapido] = useState<IAcessoRapidoItem[]>([])
	const [loading, setLoading] = useState(true)


	useEffect(() => {
		(async () => {
			try {
				const response = await api.get<IAcessoRapidoItem[]>(urls.AcessoRapido)
				setAcessoRapido(response.data)
			} catch (error) {
				// silent
			} finally {
				setLoading(false)
			}
		})()
	}, [])

	return (
		<Section>
			<SectionTitle
				title="Acesso Rápido"
				icon={<Link className="text-secondary" size={24} />}
			/>

			<div className="w-full h-auto">
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
					{loading ? (
						Array(4).fill(0).map((_, i) => (
							<Skeleton key={i} className="h-48 lg:h-36 rounded-2xl w-full" />
						))
					) : (
						acessoRapidoItem.map((item, index) => {
							const isVerde = item.cor === 'verde'
							return (
								<a
									key={index}
									href={item.url}
									target={Number(item.target) === 1 ? "_blank" : "_self"}
									rel={Number(item.target) === 1 ? "noreferrer" : undefined}
									className={`group relative h-48 lg:h-36 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] no-underline border border-border-default dark:border-white/10`}
								>
									{/* Image Background or Solid Color */}
									<div
										className={`absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110 ${isVerde ? 'bg-emerald-700' : 'bg-primary'}`}
										style={{ backgroundImage: item.imagem_fundo ? `url(${item.imagem_fundo})` : 'none' }}
									/>

									{/* Overlay Gradient */}
									<div className={`absolute inset-0 ${isVerde ? 'bg-emerald-800/60 group-hover:bg-emerald-800/40' : 'bg-primary/70 group-hover:bg-primary/50'} transition-colors duration-300`} />

									{/* Content */}
									<div className="relative h-full flex flex-col justify-end p-6 lg:p-5 z-10 bg-gradient-to-t from-black/60 via-transparent to-transparent">
										<h3 className="text-white text-xl lg:text-lg font-bold mb-1 group-hover:text-secondary transition-colors">
											{item.titulo}
										</h3>
										<p className="text-white/90 text-sm lg:text-xs line-clamp-2 leading-snug">
											{item.descricao}
										</p>

										{/* Decorative Bar */}
										<div className="absolute top-4 right-4 w-8 h-1 bg-secondary rounded-full transform scale-x-0 group-hover:scale-x-100 transition-transform origin-right duration-300"></div>
									</div>
								</a>
							)
						})
					)}
				</div>
			</div>
		</Section >
	)
}